import actionType from '../actions/actionTypes';

export interface IMediaLibrary {
    medias: any[];
    tags: ITags[];
    meta: {
        page: number;
        search: string;
    };
}

export interface ITags {
    label: string;
    value: any;
}

const initialState: IMediaLibrary = {
    medias: [],
    tags: [],
    meta: {
        page: 1,
        search: ''
    }
};

export default function (
    state: IMediaLibrary = initialState,
    action
): IMediaLibrary {
    switch (action.type) {
        case actionType.GET_ALL_MEDIA:
            const medias = [...action.payload];
            // let allTags = [];
            // medias = medias.map((media) => {
            //     let tags = JSON.parse(media.tags);
            //     tags = tags.map((tag) => {
            //         allTags.push(tag);
            //         return { label: tag, value: tag };
            //     });
            //     media.tags = tags;
            //     return media;
            // });
            // allTags = [
            //     ...Array.from(new Set(allTags)).map((tag) => {
            //         return { label: tag, value: tag };
            //     })
            // ];
            return { ...state, medias };
        case actionType.DELETE_MEDIA:
            const filteredMedias = state.medias.filter(
                (media) => media.mediaId !== action.payload
            );
            return { ...state, medias: filteredMedias };
        case actionType.UPDATE_MEDIA:
            const currentIndex = state.medias.findIndex(
                (media) => media.mediaId == action.payload.mediaId
            );

            return {
                ...state,
                medias: [
                    ...state.medias.slice(0, currentIndex),
                    {
                        ...state.medias[currentIndex],
                        label: action.payload.label
                    },
                    ...state.medias.slice(currentIndex + 1)
                ]
            };
        case actionType.SORT_MEDIA:
            const currentItem = state.medias.find(
                (media) => media.mediaId === action.payload.id
            );
            const sortedMedia = [
                currentItem,
                ...state.medias.filter(
                    (media) => media.mediaId !== action.payload.id
                )
            ];

            return { ...state, medias: sortedMedia };

        case actionType.ADD_NEW_MEDIA:
            const newMedia = { ...action.payload };
            return {
                ...state,
                medias: state.medias.length ? [newMedia, ...state.medias] : []
            };
        case actionType.CLEAR_STATE:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
